import { CloseIcon, DocumentTextIcon, UploadIcon } from "asset/icons";
import Input from "./Input";
import { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import capitalizeWords from "utilities/capitalizeWords";
import { Bars } from "react-loader-spinner";
import { Trash } from "iconsax-reactjs";

const UploadDocModal = ({ close, uploadFunc, loading, fileId }) => {
    const [name, setName] = useState("");
    const [file, setFile] = useState();
    const fileTypes = ["JPEG", "PNG", "JPG", "PDF"];

    return (
        <div className="fixed left-0 top-0 h-screen w-screen bg-[#1D29394D] z-[5000] grid place-items-center">
            <div className="bg-[#fff] rounded-[28px] w-[95%] sm:w-[600px] overflow-hidden px-8">
                <h3 className="flex justify-between items-start heading-h2-semibold text-main-dark pt-6">
                    Upload document{" "}
                    <CloseIcon
                        className={`size-6 sm:size-7 cursor-pointer shrink-0 ${
                            loading && "pointer-events-none *:stroke-main-grey/60"
                        }`}
                        onClick={close}
                    />
                </h3>

                <div className="!pt-10">
                    <Input
                        value={name}
                        onChange={setName}
                        label="Document name"
                        labelClassName="!text-[14px] sm:!text-[16px] !font-medium !text-[#475467]"
                        className="!mt-0"
                        inputClassName="!rounded-[8px] mt-2 !border-none !bg-[#f1f5f9] !shadow-[inset_0_0_0_1000px_#f1f5f9] !px-6 !text-[18px] !font-normal !text-main-dark placeholder:!text-[18px] placeholder:!font-normal placeholder:!text-[#7A80AE]"
                        placeholder="What document are you uploading"
                    />

                    <p className="font-medium text-[14px] sm:text-[16px] text-left text-[#475467] !mb-3 !mt-7 sm:!mt-8">
                        Attach document
                    </p>

                    <div className="bg-[#F4F5FF] rounded-[8px] px-4 !py-5 !border !border-dashed !border-[#E2E6FF] cursor-pointer overflow-hidden flex !gap-3 items-center relative">
                        <div className="size-[40px] rounded-full bg-[#DCCBFF] flex items-center justify-center shrink-0">
                            <UploadIcon className="size-20" />
                        </div>
                        <p className="text-main-dark">
                            <span className="aku-body-small-regular">Drag or Upload Document</span>

                            <span className="block aku-label-regular font-normal text-[14px] sm:text-[16px] text-[#7A80AE]">
                                {fileTypes.join(", ")} Max. file size: 5.0 MB 5 MB max.
                            </span>
                        </p>
                        <FileUploader
                            classes={
                                "!absolute !left-0 !top-0 !h-full !w-full !border-none !opacity-0"
                            }
                            handleChange={setFile}
                            types={fileTypes}
                            maxSize={5}
                        />
                        {file && <Document file={file} deleteFile={() => setFile(null)} />}
                    </div>
                </div>

                <div className="flex justify-end items-center !gap-6 !border-t !border-[#E7E9FB] !py-6">
                    <button
                        type="button"
                        className="!px-1  aku-body-normal-medium  text-[#475467] disabled:text-main-grey/60"
                        onClick={close}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="bg-[#6F00FF] rounded-[8px] !px-8 py-2.5 aku-body-normal-medium text-[#FBFAFF] disabled:bg-secondary/30"
                        disabled={!file || loading}
                        onClick={() => uploadFunc?.(file, name, fileId)}
                    >
                        {loading ? (
                            <Bars
                                color="#fff"
                                height={23}
                                width={23}
                                wrapperClass="w-max mx-auto"
                            />
                        ) : (
                            "Save document"
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

const Document = ({ deleteFile, file }) => {
    const namesArr = file?.name?.split(".");
    const rawName = file?.name ?? "";
    const displayName =
        rawName ||
        capitalizeWords(namesArr?.[0]?.replace(/[^a-zA-Z0-9]/g, " ")?.toLowerCase() ?? "");
    const fileSizeInMb = file?.size
        ? `${Math.max(1, Math.round(file.size / (1024 * 1024)))} MB`
        : "";

    return (
        <div className="bg-[#f1f5f9] rounded-[8px] !px-4 !py-5 flex items-center absolute left-0 top-0 w-full h-full">
            <div className="size-[40px] rounded-full bg-[#DCCBFF] flex items-center justify-center shrink-0">
                <DocumentTextIcon className="size-5" />
            </div>
            <div className="min-w-0 ml-4 mr-auto">
                <p className="aku-body-small-regular text-main-dark truncate">{displayName}</p>
                <p className="aku-label-regular text-[#7A80AE]">{fileSizeInMb}</p>
            </div>
            {deleteFile && (
                <button
                    type="button"
                    className="shrink-0 text-[#6F739B]"
                    onClick={deleteFile}
                    aria-label="Delete uploaded document"
                >
                    <Trash className="size-5" />
                </button>
            )}
        </div>
    );
};

export default UploadDocModal;
